export const FINDER_FILTER_ORDER_ACTIVATION = "activation";

export const FINDER_FILTER_ORDER_DOCUMENT = "document";
